<template>
    <div>
        <v-row no-gutters>
            <v-col cols="2">
                <v-card @click="ctrl.addQuestion()">
                    <v-overlay absolute v-if="question_ctrl.loading">
                        <v-progress-circular indeterminate></v-progress-circular>
                    </v-overlay>
                    <v-row no-gutters justify="center" align="center">
                        <span class="subtitle-1">
                            <b> Add Question</b>
                        </span>
                    </v-row>
                    <v-divider></v-divider>
                    <v-col cols="12">
                        <img src="@/assets/icons/question.png" alt="" width="100%" />
                    </v-col>
                </v-card>
            </v-col>
        </v-row>

        <v-divider class="my-2"></v-divider>
    </div>
</template>

<script>
export default {
    props: {
        ctrl: Object,
        question_ctrl: Object
    }
}
</script>